// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"d664d0e2","492":"59794ab4","864":"772b4e00"}[chunkId] + ".chunk.js";
};